import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { INavItem } from '@/component/layout/SideNav/SideNavItem.tsx'
import DashboardIcon from '@/assets/ic_side_nav_dashboard.svg?react'
import UsersIcon from '@/assets/ic_side_nav_users.svg?react'
import NotificationIcon from '@/assets/ic_side_nav_notification.svg?react'
import HealthIcon from '@/assets/ic_side_nav_health.svg?react'

export const useNavItems = () => {
    const { t } = useTranslation()

    return useMemo<INavItem[]>(() => [
        {
            id: 'dashboard',
            label: t('sideNav.menu.dashboard'),
            href: `/dashboard`,
            icon: DashboardIcon
        },
        {
            id: 'user',
            label: t('sideNav.menu.users'),
            href: `/user`,
            icon: UsersIcon
        },
        {
            id: 'notification',
            label: t('sideNav.menu.notification'),
            href: `/notification?tab=sos`,
            icon: NotificationIcon
        },
        {
            id: 'mental-health',
            label: t('sideNav.menu.HealthCare'),
            href: `/mental-health`,
            icon: HealthIcon,
            disabled: false
        }
    ], [t])
}
